import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PopupListRes;
export const PopupListTodo = createAsyncThunk('PopupList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'popup_data',
            params:{
                "status": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return PopupListRes = res.data

    } catch (error) {
        return PopupListRes = error.response.data
    }
})

const PopupListSlice = createSlice({
    name: 'PopupList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PopupListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(PopupListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PopupListSlice.reducer; 